module.exports = __webpack_public_path__ + "static/media/legendary-paint-zoom.be745e97.png";